// import { SUPPORT_CROSS_SWAP } from 'config/constants/supportChains'
// import CrossSwap from '../views/CrossSwap'

// const CrossSwapPage = () => {
//   return <CrossSwap />
// }

// CrossSwapPage.chains = SUPPORT_CROSS_SWAP

// export default CrossSwapPage

import {
  // SUPPORT_SWAP,
  SUPPORT_ANY,
} from 'config/constants/supportChains'
import Landing from 'views/Landing'

const HomePage = () => {
  return <Landing />
}

// HomePage.chains = []
HomePage.chains = SUPPORT_ANY

export default HomePage

// const HomePage = () => {
//   return <></>
// }

// HomePage.chains = []

// export default HomePage

// export async function getStaticProps() {
//   return {
//     notFound: true,
//   }
// }
